import React from 'react';
import { Table } from 'semantic-ui-react';
import { allSelected } from '@/utils/resultsHelper';
import {
  columnMultiSelect,
  columnSelect,
  columnTools,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from './UnsortedColumn';
import SelectColumn from './SelectColumn';

const StandardColumns = ({
  children,
  className,
  columns = [],
  entity,
  items = [],
  onCheckBoxClick,
  toolsWidth,
}) => (
  <Table.Row className={className}>
    {hasColumn(columns, columnMultiSelect) && (
    <SelectColumn
      entity={entity}
      disabled={items.length === 0}
      selected={allSelected(items)}
      onCheckBoxClick={() => onCheckBoxClick({ selected: !allSelected(items) })}
    />
    )}
    {hasColumn(columns, columnSelect) && !hasColumn(columns, columnMultiSelect) && (<UnsortedColumn />)}
    {children}
    {hasColumn(columns, columnTools) && <UnsortedColumn colWidth={toolsWidth} />}
  </Table.Row>
);

export default StandardColumns;
